import React from "react";
import { ArrowRight } from "lucide-react";
import "./HubAcreSection.css";

const HubAcreSection = () => {
  return (
    <section className="ima-hub-section">
      <div className="ima-hub-bg-text" aria-hidden="true">
        ACRE
      </div>

      <div className="ima-hub-container">

        <div className="ima-hub-content">

          <img
            src="/hubacre/logo-horizontal.png"
            alt="Hub Acre"
            className="ima-hub-logo"
          />

          <div className="ima-hub-kicker">
            INOVAÇÃO
            <span>•</span>
            CONEXÃO
            <span>•</span>
            DESENVOLVIMENTO
          </div>

          <h2>
            Um espaço para
            <br />
            conectar ideias
            <br />
            e transformar
            <br />
            <strong>oportunidades.</strong>
          </h2>

          <a
            href="/hubacre"
            className="ima-hub-button"
          >
            Acesse o Hub Acre
            <ArrowRight size={21} />
          </a>

        </div>

        <div
          className="ima-hub-visual"
          aria-hidden="true"
        >
          <div className="ima-hub-orbit ima-hub-orbit-one" />
          <div className="ima-hub-orbit ima-hub-orbit-two" />

          <div className="ima-hub-circle">
            <img
              src="/hubacre/simbolo-circular.png"
              alt=""
            />
          </div>

          <span className="ima-hub-dot ima-hub-dot-one" />
          <span className="ima-hub-dot ima-hub-dot-two" />
          <span className="ima-hub-dot ima-hub-dot-three" />
        </div>

      </div>
    </section>
  );
};

export default HubAcreSection;
